import {
  buildParentIdMap,
  filterNodes,
  filterNodesByText,
} from '@trimble/ui-components/solidjs';
import type { TreeNodeDefinition } from '@trimble/ui-components/solidjs';
import type { ProjectDataFilterMode } from './project-data.types';

export interface ProjectDataFilterResult<T> {
  nodes: TreeNodeDefinition<T>[];
  expandIds: string[];
}

export const filterProjectDataNodes = <T>(
  nodes: TreeNodeDefinition<T>[],
  filterMode: ProjectDataFilterMode,
  filterText: string | undefined,
  activeFilter: (node: TreeNodeDefinition<T>) => boolean
): ProjectDataFilterResult<T> => {
  const parentIdMap = buildParentIdMap(nodes);
  const normalizedFilter = filterText?.trim().toLowerCase() ?? '';
  const expandIds = new Set<string>();
  let visibleIds: Set<string> | undefined;

  if (filterMode === 'active') {
    const result = filterNodes(nodes, activeFilter, parentIdMap);
    visibleIds = result.visibleIds;
    result.expandIds.forEach((id) => expandIds.add(id));
  }

  if (normalizedFilter.length > 0) {
    const ids = visibleIds;
    const nodesToSearch = ids
      ? nodes.filter((node) => ids.has(node.id))
      : nodes;
    const result = filterNodesByText(
      nodesToSearch,
      normalizedFilter,
      parentIdMap
    );

    visibleIds = result.visibleIds;
    result.expandIds.forEach((id) => expandIds.add(id));
  }

  const ids = visibleIds;
  return {
    nodes: ids ? nodes.filter((node) => ids.has(node.id)) : nodes,
    expandIds: Array.from(expandIds),
  };
};

export const countRootNodes = <T>(nodes: TreeNodeDefinition<T>[]): number =>
  nodes.filter((node) => node.parentId === undefined).length;
